import { GzzTelephone } from "../general/GzzTelephone";
import { GzzAddress } from "../general/GzzAddress";

export class GzzRepresenter {

  Name: string;
  LicenseNumber: string;
  OfficeName: string;
  PrivateCompany: string;
  PhoneNumber: GzzTelephone;
  MobileNumber: GzzTelephone;
  FaxNumber: GzzTelephone;
  Email: string;
  Address: GzzAddress;

  constructor(data) {

    Object.assign(this, data);

    if (data) {
      if (data.PhoneNumber) {
        this.PhoneNumber = new GzzTelephone(data.PhoneNumber);
      }

      if (data.MobileNumber) {
        this.MobileNumber = new GzzTelephone(data.MobileNumber);
      }

      if (data.FaxNumber) {
        this.FaxNumber = new GzzTelephone(data.FaxNumber);
      }

      if (data.Address) {
        this.Address = new GzzAddress(data.Address);
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/models/general/GzzRepresenter.ts